<template>
  <div class="filling-goods-div">
    <div style="padding-top: 5px; font-size: 16px">布匹拣货</div>
    <div class="goodsorder-head">
      <div class="goodsorder-list">订单号:<div class="goodsorder-number">{{ orderdata.order_number }}</div>
      </div>
      <div class="goodsorder-head-div">
        <div class="head-list-div">
          <div style=" text-align: left">产品名称:{{ orderdata.goods_name }}</div>
        </div>
        <div class="head-list-div">
          <div style="text-align: left">规格:{{ orderdata.goods_normtype }}</div>
        </div>
        <div class="head-list-div">
          <div style="text-align: left">门幅:{{ orderdata.mf }}</div>
        </div>
        <div class="head-list-div">
          <div style="text-align: left">货号:{{ orderdata.goods_number }}</div>
        </div>
        <div class="head-list-div">
          <div style="text-align: left">明细码:{{ orderdata.gck_number }}</div>
        </div>
        <div class="head-list-div">
          <div style="text-align: left">匹数:{{ orderdata.ps }}</div>
        </div>
        <div class="head-list-div">
          <div style="text-align: left">已拣匹数:{{ orderdata.yjhps }}</div>
        </div>
        <div class="head-list-div">
          <div style="text-align: left">需求:{{ orderdata.rolling_method }}/{{ orderdata.client_grade }}</div>
        </div>
        <div class="head-list-div">
        </div>
      </div>
    </div>
    <span style="color: red" v-if="hostcs">测试服</span>
    <div style="display: flex; justify-content: space-between; align-items: center">
      <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
      <div>
        <input id="reel-input" class="get-input-reel" @keyup.enter="AddReel(reeldata)" ref="getIDInpot" v-model="reeldata"
          v-on:blur="hideMessage('reeldata')" readonly autocomplete="off" />
      </div>
    </div>
    <van-dialog v-model="showConfirm" title="请确认" show-cancel-button @confirm="addPick()" @cancel="delPick()"
      :before-close="pickClose">
      <div class="dialog-div">
        <div style="text-align: left; width: 50%;">卷号:{{ SingleData.reel }}</div>
        <div style="text-align: left; width: 50%;">门幅:{{ SingleData.menfu }}</div>
      </div>
      <div class="dialog-div">
        <div style="text-align: left; width: 50%;">货号:{{ SingleData.number }}</div>
        <div style="text-align: left; width: 50%;">产品名称:{{ SingleData.name }}</div>
      </div>
      <div class="dialog-div">
        <div style="text-align: left; width: 50%;">数量:{{ SingleData.store }}</div>
      </div>
    </van-dialog>
    <div :style="style">
      <div class="goods-info-two" v-for="(i, index) in data" :key="index">
        <div class="info-order-div">
          <span class="info-order-l">
            <div style="font-weight: bold;">卷号:</div>
            <div>{{ i.reel }}</div>
          </span>
          <span class="info-order-l">
            <div style="font-weight: bold;">门幅:</div>
            <div>{{ i.dpmf }}</div>
          </span>
          <span class="info-order-l">
            <div style="font-weight: bold;">货号:</div>
            <div>{{ i.number }}</div>
          </span>
          <span class="info-order-l">
            <div style="font-weight: bold;">数量:</div>
            <div>{{ i.store }}米</div>
          </span>
          <span class="info-order-l" style="width: 100%; align-items: center;">
            <div style="font-weight: bold;">备注:</div>
            <input type="text" v-model="i.reel_detail" style="width: 80%; height: 20px;">
            <!-- <div>{{ i.reel }}</div> -->
          </span>
        </div>
        <div>
          <van-icon name="cross" @click="deleteData(index, i['gck_number'])" style="margin: 5px 0" />
        </div>
      </div>
    </div>
    <div class="filling-goods-bottom" style="display: flex; align-items: center;">
      <van-button type="warning" class="bottom-button" @click="go_index()">返回</van-button>
      <van-button type="info" class="bottom-button" @click="PickGoods()">确认拣货</van-button>
      <div style="margin: 0 10px;">已扫匹数：{{ ps_count}}</div>
      <div>总米数：{{ meter_count}}</div>
      <!-- <van-button
          v-if="outNumber !== '未出库'"
          type="default"
          class="bottom-button"
          style="background-color: darkgray"
          >确认出库</van-button
        >
        <van-button
          v-if="outNumber !== '未出库'"
          type="info"
          class="bottom-button"
          @click="revocation(id)"
          >撤销出库</van-button
        >
        <van-button
          v-if="outNumber === '未出库'"
          type="default"
          class="bottom-button"
          style="background-color: darkgray"
          >撤销出库</van-button
        >
        <van-button
          type="warning"
          class="bottom-button"
          style="margin: 0"
          @click="more_show = true"
        >
          更多
        </van-button>
        <van-button
          class="bottom-button"
          type="warning"
          style="width: 10%"
          @click="resetClick()"
        >
          +
        </van-button> -->
    </div>
  </div>
</template>
  
<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  name: "FabricPicking",
  data() {
    return {
      hostcs: false,
      more_show: false,
      ray: "扫描中",
      id: "",
      style: "",
      goods_number: "",
      reelInfo: "",
      reelInfo_up: "",
      infoType: "1111",
      username: "",
      type: "FabricPicking",
      success: false,
      ps_count: 0,
      meter_count:0,
      //xin
      orderdata: '',
      reeldata: "",
      data: [],
      reeldata_haveAll: {},
      showConfirm: false,
      SingleData: '',
      isButtonClicked: false, //防止多次点击问题
      PickGoodsType: true,//防止拣货多次点击连续出库问题
    };
  },
  mounted() {
    if (typeof this.$route.query.data !== 'undefined') {
      this.orderdata = this.$route.query.data;
      console.log(this.orderdata);
    }
    this.username = JSON.parse(window.localStorage.getItem("userinfo"));
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.style =
      "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
    setTimeout(() => {
      this.focus();
    }, 500);
    if (window.location.host.indexOf("cspda") !== -1) {
      this.hostcs = true;
    }
  },
  methods: {
    AddReel(reeldata) {  //新增卷号
      if (this.reeldata_haveAll[reeldata] !== undefined) {
        Toast("该卷号已扫，请勿重复扫码!");
        this.reeldata = "";
        return;
      }
      const objKeys = Object.keys(this.reeldata_haveAll).length;
      console.log(objKeys);
      const numC = Number(this.orderdata.ps) - Number(this.orderdata.yjhps);
      if (objKeys >= numC) {
        Dialog.confirm({
          message: "匹数已经大于等于所需匹数,是否继续!",
        }).then(() => {
          this.PickApi(reeldata);
        }).catch(() => {
          // on cancel
          this.reeldata = "";
          return;
        });
      } else {
        this.PickApi(reeldata);
      }
    },
    PickApi(reeldata) {
      //接口 拿取数据  
      this.get(this.APIOBJ.isReel, {
        reel: this.reeldata,
        gck_number: this.orderdata.gck_number,
      }).then((res) => {
        const Rdata = res.data.data;
        if (res.data.status == 1) {
            this.reeldata_haveAll[reeldata] = "";
            this.showConfirm = true;
            //var newData = { ...res.data.data.norms_ware, mf: res.data.data.goodsorder.mf };  //提取goodsorder中的mf 合并到 norms_ware
            // const { all, goods, num, normsware, ...restData } = res.data.norms_ware; //对接口中的数据处理
            // const newData = { ...restData, ...goods, ...all, num, normsware };
            //console.log(newData);
            this.SingleData = res.data.data.norms_ware;
        } else { this.reeldata = "";Toast(res.data.msg);}
      });
    },
    deleteData(index) {
      Dialog.confirm({
        message: "确定要删除该卷号吗？",
      }).then(() => {
        let mxm = this.data[index].reel;
        this.meter_count = (this.meter_count - Number(this.data[index].store)).toFixed(2);;
        this.ps_count--;
        this.data.splice(index, 1);
        delete this.reeldata_haveAll[mxm];
      }).catch(() => {
        // on cancel
      });
    },
    addPick() {
      if (this.isButtonClicked) {
        return; // 已经点击过了，不再执行后续代码
      }
      this.isButtonClicked = true;
      try {
        let newData = {};
        newData["reel"] = this.SingleData.reel;
        newData["number"] = this.SingleData.number;
        newData["reel_detail"] = this.SingleData.reel_detail;
        newData["store"] = this.SingleData.store;
        newData["dpmf"] = this.SingleData.menfu;
        this.data.push(newData);
        this.reeldata = "";
        this.ps_count++;
        this.meter_count = this.meter_count + Number(this.SingleData.store);
      } catch (error) {
        console.error(error);
      } finally {
        this.isButtonClicked = false;
        this.showConfirm = false;
      }
    },
    pickClose(action, done) {  //防止多次点击问题
      if (this.isButtonClicked) {
        done(false); // 已经点击过了，不允许关闭弹窗
        return;
      }
      this.isButtonClicked = true;
      setTimeout(() => {
        done(); // 允许关闭弹窗
        this.isButtonClicked = false;
      }, 500); // 延迟1秒钟关闭弹窗
    },
    delPick() {
      delete this.reeldata_haveAll[this.reeldata];
      this.reeldata = "";
      this.showConfirm = false;
    },
    async PickGoods() {
      console.log(this.data);
      if (this.data.length === 0) {
        return;
      }
      if (!this.PickGoodsType) {
        Toast("不要连续拣货");
        return;
      }
      this.PickGoodsType = false;
      let newArray = [];
      for (let key in this.data) {
        newArray.push({
          reel: this.data[key].reel,
          reel_detail: this.data[key].reel_detail
        });
      }
      this.get(this.APIOBJ.doGoodsorder, {
        data: newArray,
        gck_number: this.orderdata.gck_number,
      }).then((res) => {
        if(res.data.status == 1){
          Toast(res.data.msg);
        }else{
          Toast(res.data.msg);
          this.PickGoodsType = true;
        }
      });
    },
    hideMessage(title) {
      if (title === "reeldata") {
        if (this.reeldata === "") {
          this.ray = "已暂停，点击我继续扫码";
        }
      }
      if (title === "gck_number_data") {
        if (this.gck_number_data === "") {
          this.ray = "已暂停，点击我继续扫码";
        }
      }
    },
    holdRay() {
      this.ray = "扫描中";
      if (this.reeldata === "") {
        this.focus();
      } else if (this.gck_number_data === "") {
        this.gck_input();
      }
    },
    focus() {
      this.$refs.getIDInpot.focus();
      this.$refs.getIDInpot.setAttribute("readonly", "readonly");
      setTimeout(() => {
        this.$refs.getIDInpot.removeAttribute("readonly");
      }, 200);
    },
    go_index() {
      Dialog.confirm({
        message: "确定要返回上一步吗？",
      })
        .then(() => {
          this.$router.push("/orderDetailsList");
        })
        .catch(() => {
          // on cancel
        });
    },
    go_scan_url() {
      let url =
        "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
      window.location.href = url;
    },
    // async getIdData(id) {
    //   //订单详情页
    //   let idData = await this.get(this.APIOBJ.out_detail, { id });
    //   console.log(idData.data.data.out);
    //   this.count = Number(idData.data.data.out.normsware).toFixed(2);
    //   this.data = idData.data.data.out_detail;
    //   this.outNumber = idData.data.data.out.status;
    //   this.reeldata = idData.data.data.out_detail[0].reel;
    //   for (let i of idData.data.data.out_detail) {
    //     this.gck_number_data_haveAll[i.mxm] = "";
    //   }
    //   this.infoType = "";
    //   this.out_num = idData.data.data.out.out_num;
    //   this.id = id;
    // },
  },
};
</script>
  
<style lang="less">
@import "../style/outOrderInfo.less";

.goodsorder-list {
  display: flex;
  text-align: left;
  padding: 10px 10px 0px 10px;
  height: 20px;
}

.get-input-reel {
  height: 20px;
  width: 3rem
}

.goodsorder-number {
  display: flex;
  background-color: rgb(221, 220, 220);
  width: 70%;
  align-items: center;
  justify-content: center;
  margin: 0px 10px 0px 10px;
}

.goodsorder-head-div {
  display: flex;
  padding: 0px 10px 0px 10px;
  margin: 10px 0 10px 0;
  background-color: rgb(240, 239, 239);
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.head-list-div {
  width: 32%;
  padding: 10px 0 10px 0;
}

.dialog-div {
  padding: 10px 30px;
  display: flex;
}

// .dialog-div{
//   padding: 10px 20px;
//   display: flex;
// }
.info-order-div {
  width: 100%;
  display: flex;
  padding-top: 5px;
  align-items: center;
  flex-wrap: wrap;

}

.info-order-l {
  margin-right: 20px;
  padding: 10px;
  display: flex;
  width: 35%;
  display: flex;
  align-items: flex-end;
}

.van-dialog__header {
  padding-top: 25px;
  font-weight: 500;
  text-align: center;
  font-size: 18px;
}
</style>